module.exports = __webpack_public_path__ + "img/connections-mobile-circles.f7586934.png";